import { SentryEnvironment } from '@techniek-team/sentry-web';
import { EnvironmentModel } from './environment.model';

export const environmentMock: EnvironmentModel = {
  production: false,
  environment: SentryEnvironment.LOCAL,
  release: '1.0.0',
  sentryDsn: '',
  homiApiUrl: '',
  authConfig: {
    issuer: '',
    clientId: '',
    responseType: '',
    scope: '',
    useSilentRefresh: '',
    sessionChecksEnabled: true,
    clearHashAfterLogin: true,
    nonceStateSeparator: '',
  },
  authModuleConfig: {
    resourceServer: {
      allowedUrls: [],
      sendAccessToken: true,
    },
  },
  gitlabFeatureFlags: {
    url: '',
    clientKey: '',
    environment: '',
  },
  loginDomain: '',
  issuerUrl: '',
};
